import { render, staticRenderFns } from "./full-loader.vue?vue&type=template&id=1845eca1"
import script from "./full-loader.vue?vue&type=script&lang=js"
export * from "./full-loader.vue?vue&type=script&lang=js"
import style0 from "./full-loader.vue?vue&type=style&index=0&id=1845eca1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports